import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import vi from "./locales/vi.json";
import en from "./locales/en.json";

export const defaultNS = "translation";
export const resources = {
  vi: { translation: vi },
  en: { translation: en },
} as const;

export type SupportedLanguage = "vi" | "en";

export const getSavedLanguage = (): SupportedLanguage => {
  const saved = localStorage.getItem("mooc_language");
  if (saved === "en" || saved === "vi") {
    return saved;
  }
  return "vi";
};

const currentLang = getSavedLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: currentLang,
  fallbackLng: "vi",
  interpolation: {
    escapeValue: false,
  },
});

export const changeLanguage = async (lng: SupportedLanguage) => {
  await i18n.changeLanguage(lng);
  localStorage.setItem("mooc_language", lng);
  document.documentElement.lang = lng;
};

export default i18n;
